<template>
    <div>
        <vue-headful title="Subcontractor Users :: MeritEHS"/>

        <h4 class="py-2 mb-2">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`/subcontractors`">
                        <i class="fa fa-id-badge"></i> Subcontractors
                    </router-link>
                </li>
                <li class="breadcrumb-item active"><i class="fa fa-group"></i> Users</li>
                <li class="ml-3 d-none d-sm-inline-block">
                    <router-link :to="`/users/create`" class="btn btn-sm btn-success"><i class="fa fa-plus-circle"></i> Create</router-link>
                </li>
            </ol>
        </h4>

        <div class="d-block d-sm-none mt-3 mb-3">
            <router-link :to="`/users/create`" class="btn btn-sm btn-success"><i class="fa fa-plus-circle"></i> Create</router-link>
        </div>

        <div class="card">
            <div class="card-body">
                <v-server-table ref="userTable" url="/subcontractors/users/list" :columns="columns" :options="options">

                    <div slot="afterFilterWrapper" class="ml-md-2 ml-0 mt-md-0 mt-2 mb-md-0 mb-3 float-md-left">
                        <div class="clearfix d-md-none d-block"></div>

                        <button type="button" class="btn btn-outline-success" v-on:click="exportTable()" :disabled="exportingTable">
                            <template v-if="!exportingTable"><i class="fa fa-file-excel-o"></i> Export</template>
                            <template v-else><i class="fa fa-circle-o-notch fa-spin"></i> Exporting</template>
                        </button>

                        <div class="clearfix d-md-none d-block"></div>
                    </div>

                    <router-link slot="UserId" slot-scope="props" :to="`/users/edit/${props.row.UserId}`" :title="`View ${props.row.FirstName} ${props.row.LastName}`" class="btn btn-sm btn-light">
                        Edit
                    </router-link>

                    <router-link slot="LastName" slot-scope="props" :to="`/users/view/${props.row.UserId}`" :title="`View ${props.row.FirstName} ${props.row.LastName}`">
                        {{ props.row.FirstName }} {{ props.row.LastName }}
                    </router-link>

                    <template slot="created_at" slot-scope="props">
                        {{ props.row.created_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }}
                    </template>

                    <template slot="LastLoginDate" slot-scope="props">
                        {{ props.row.LastLoginDate | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }}
                    </template>

                    <template slot="email" slot-scope="props">
                        <a :href="`mailto:${props.row.email}`">{{ props.row.email }}</a>
                    </template>

                    <router-link slot="subcontractor_name" slot-scope="props" :to="`/subcontractors/view/${props.row.subcontractor_id}`" :title="`View ${props.row.subcontractor_name}`">
                        {{ props.row.subcontractor_name }}
                    </router-link>

                    <template slot="IsActive" slot-scope="props">
                        <span class="badge badge-success" v-if="props.row.IsActive == 1">Active</span>
                        <span class="badge badge-warning" v-else>Inactive</span>
                    </template>

                </v-server-table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['assetType', 'assetId'],

        data: function() {
            return {
                exportingTable: false,
                userTimezone: this.$store.state.user.timezone,
                columns: ['UserId', 'LastName', 'email', 'subcontractor_name', 'created_at', 'LastLoginDate', 'IsActive'],
                options: {
                    headings: {
                        UserId: 'ID',
                        LastName: 'Name',
                        subcontractor_name: 'Subcontractor',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'user.LastName',
                    },
                    requestAdapter: (data) => {
                        // //How do we get the filters
                        // data.filters = this.$store.state.tableFilters.incidentFilters;

                        // //Parse the filters
                        // //data.filters['incident.IncidentTypeId'] = [];

                        // //console.log(this.$store.state.tableFilters.incidentFilters['incident.IncidentTypeId']);

                        // for(var i = 0; i <= this.$store.state.tableFilters.incidentFilters['incident.IncidentTypeId'].length; i++)
                        // {
                        //     //Add each id
                        //     //data.filters['incident.IncidentTypeId'].push(this.$store.state.tableFilters.incidentFilters['incident.IncidentTypeId'][i]['id']);
                        // }

                        //INclude the asset
                        data.assetType = this.assetType
                        data.assetId = this.assetId

                        //Send it
                        return data;
                    },
                    uniqueKey: 'UserId',
                },
            }
        },

        methods: {

            exportTable(){
                //Loading indicator
                this.exportingTable = true;

                //Build the payload
                var payload = {
                    table: 'userTable',
                    query: (this.$refs.userTable.getRequestParams()).query,
                    orderBy: this.$refs.userTable.options.orderBy.column,
                    ascending: this.$refs.userTable.options.orderBy.ascending,
                    columns: this.$refs.userTable.columns,
                };

                //Send it
                this.$http.get('/subcontractors/users/list?export=true', payload)
                    .then(response => {
                        //Open the new window
                        window.open(response.data);
                    })
                    .catch(err => {
                        //Alert the user
                        this.$toastr.error(err.response.data, 'Failed to Export Users');
                    })
                    .then(response => {
                        //reset
                        this.exportingTable = false;
                    });
            }

        },

        mounted(){

        }
    }
</script>
